import { DeviceStats } from '@/features/devices/components/DeviceStats'
import { Block, Spinner, Text } from '@/ui-kit'
import { useUiKit } from '@/ui-kit/providers'
import { formatNumber } from '@/utils'
import { useCallback, useEffect, useState } from 'react'
import { Worker } from '../api/models'
import { useFetchWorkers } from '../api/useFetchWorkers'
import { DevicesList } from './DevicesList/DevicesList'
import { NoDevicesPlaceholder } from './NoDevicesPlaceholder'

const anchorId = 'devices-anchor'

const DEVICES_COLUMN_DEFS = () => [
  {
    name: 'Points 24h',
    value: (worker: Worker) => formatNumber(worker.points24h, 0)
  }
  /* {
    name: '',
    value: (worker: Worker) =>
      !worker.archived ? (
        <Button
          variant="bordered-gray"
          size="small"
          className="ml-auto mr-4 mt-[3px] border-none p-2 text-gray-500 hover:bg-transparent max-mobile:absolute max-mobile:right-0 max-mobile:top-0 max-mobile:mr-1"
          onClick={() => archiveDevice(worker.id)}
        >
          <Archive height={16} />
        </Button>
      ) : (
        <p className="mr-4 text-end text-sm text-gray-500" onClick={() => unarchiveDevice(worker.id)}>
          Archived
        </p>
      )
  } */
]

export function Devices(): React.JSX.Element {
  /*   const [showArchived, setShowArchived] = useLocalStorage('DH_SHOW_ARCHIVED', false) */
  const { data: workers = [], isFetched } = useFetchWorkers(true)
  /*   const { mutateAsync: archiveDevice } = useArchiveDevice() */
  const { isMobile } = useUiKit()
  const [selectedWorkerId, setSelectedWorkerId] = useState('')
  const selectedWorker: Worker | null = workers.find((worker) => worker.id === selectedWorkerId) ?? null

  useEffect(() => {
    if (isFetched) {
      setSelectedWorkerId(workers.length ? workers[0].id : '')
    }
  }, [isFetched, workers])

  const onWorkerClick = useCallback(
    (id: string) => {
      setSelectedWorkerId(id)
      if (isMobile) {
        document.getElementById(anchorId)!.scrollIntoView({ block: 'start', behavior: 'smooth' })
      }
    },
    [isMobile]
  )

  return isFetched && workers.length <= 0 ? (
    <NoDevicesPlaceholder />
  ) : (
    <>
      <Block className="mt-5 max-mobile:mt-6 max-mobile:border-0 max-mobile:p-0">
        <div className="flex items-start justify-between">
          <Text className="mr-4 pr-4" type="subtitle-semibold">
            Devices
          </Text>
          {/*  <CheckBox
            defaultChecked={showArchived}
            checked={showArchived}
            onChange={(value) => {
              setShowArchived(Boolean(value))
            }}
            label={'Show archived'}
            className="text-gray-90"
          /> */}
        </div>
        <DevicesList
          columns={DEVICES_COLUMN_DEFS()}
          workers={workers}
          selectedWorkerId={selectedWorkerId}
          setSelectedWorkerId={onWorkerClick}
        />
      </Block>
      <div id={anchorId} className="flex flex-1 scroll-mt-[var(--header-height)]">
        {workers === undefined ? (
          <Spinner className="scaleInOutAnimation m-auto" />
        ) : selectedWorker ? (
          <DeviceStats worker={selectedWorker} />
        ) : (
          <Text className="text-gray-90 hidden max-mobile:block">No data available yet</Text>
        )}
      </div>
    </>
  )
}
